export default {
  title: 'ЦДС Телебух',
  startPage: '/',
  topBar: false,
};
